/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { whenSideBySide, assignFormDesignToCSSVars } from '../fields-customise.style';
import { FormContext } from '../../../customise/contexts/form-context';
import SpecialPropsIndicators from '../props-Indicator/special-props';
import { ctrlDefaults } from '../../../../shared/form-lib';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import PayPalSubComponent from './paypal-sub';
import {
  ValidationWarning,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  InputWrapper,
  Field,
} from '../../common-field-styles';

const Paypal = ({ ctrl, formDesign, isRenderedOnModal }) => {
  const { isPayOnSubmission } = useSelector((state) => state.form);
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const { inBuilder } = useContext(FormContext);

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrl._validationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrl._validationError}</ValidationWarning>
        )}

        <Field className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
          {!isPayOnSubmission && (
            <LabelWrapper
              className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}
              required={ctrl.props.required}
              notInBuilder={!inBuilder}>
              <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }} />
              <SpecialPropsIndicators ctrl={ctrl} />
            </LabelWrapper>
          )}

          <InputWrapper id={`fpl-${ctrl.internal_id}`} className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            <PayPalSubComponent ctrl={ctrl} formDesign={formDesign} isRenderedOnModal={isRenderedOnModal} />
            
            <SubtextWrapper id="descriptive text" notInBuilder={!inBuilder}>
              {ctrl.props.subtext}
            </SubtextWrapper>
          </InputWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

Paypal.defaultProps = {
  isRenderedOnModal: false,
  formDesign: null,
};

Paypal.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  isRenderedOnModal: PropTypes.bool,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default Paypal;
